import { render, staticRenderFns } from "./swatch_list.vue?vue&type=template&id=50e269f8&scoped=true&"
import script from "./swatch_list.vue?vue&type=script&lang=js&"
export * from "./swatch_list.vue?vue&type=script&lang=js&"
import style0 from "./swatch_list.vue?vue&type=style&index=0&id=50e269f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e269f8",
  null
  
)

export default component.exports